"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _typeof = require("@babel/runtime/helpers/typeof");

var _regeneratorRuntime = require("@babel/runtime/regenerator");

var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");

var _createClass = require("@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkProvider = void 0;

var bn_js_1 = __importDefault(require("bn.js"));

var util_1 = require("../util");

var eth_eip712_util_1 = __importDefault(require("../vendor-js/eth-eip712-util"));

var FilterPolyfill_1 = require("./FilterPolyfill");

var JSONRPC_1 = require("./JSONRPC");

var eth_rpc_errors_1 = require("eth-rpc-errors");

var safe_event_emitter_1 = __importDefault(require("@metamask/safe-event-emitter"));

var SubscriptionManager_1 = require("./SubscriptionManager");

var LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";

var WalletLinkProvider = /*#__PURE__*/function (_safe_event_emitter_) {
  _inherits(WalletLinkProvider, _safe_event_emitter_);

  var _super = _createSuper(WalletLinkProvider);

  function WalletLinkProvider(options) {
    var _this;

    _classCallCheck(this, WalletLinkProvider);

    _this = _super.call(this);
    _this._filterPolyfill = new FilterPolyfill_1.FilterPolyfill(_assertThisInitialized(_this));
    _this._subscriptionManager = new SubscriptionManager_1.SubscriptionManager(_assertThisInitialized(_this));
    _this._relay = null;
    _this._addresses = [];
    _this.hasMadeFirstChainChangedEmission = false; // true if mobile client has sent message to override jsonRpcUrl+chainId

    _this.isChainOverridden = false;
    _this._send = _this.send;
    _this._sendAsync = _this.sendAsync;
    _this.setProviderInfo = _this.setProviderInfo.bind(_assertThisInitialized(_this));
    _this.updateProviderInfo = _this.updateProviderInfo.bind(_assertThisInitialized(_this));
    _this.setAppInfo = _this.setAppInfo.bind(_assertThisInitialized(_this));
    _this.enable = _this.enable.bind(_assertThisInitialized(_this));
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    _this.send = _this.send.bind(_assertThisInitialized(_this));
    _this.sendAsync = _this.sendAsync.bind(_assertThisInitialized(_this));
    _this.request = _this.request.bind(_assertThisInitialized(_this));
    _this._setAddresses = _this._setAddresses.bind(_assertThisInitialized(_this));
    _this.scanQRCode = _this.scanQRCode.bind(_assertThisInitialized(_this));
    _this.arbitraryRequest = _this.arbitraryRequest.bind(_assertThisInitialized(_this));
    _this.childRequestEthereumAccounts = _this.childRequestEthereumAccounts.bind(_assertThisInitialized(_this));
    _this._chainId = util_1.ensureIntNumber(options.chainId || 1);
    _this._jsonRpcUrl = options.jsonRpcUrl;
    _this._overrideIsMetaMask = options.overrideIsMetaMask;
    _this._relayProvider = options.relayProvider;
    _this._storage = options.storage;
    _this._relayEventManager = options.relayEventManager;
    var chainIdStr = util_1.prepend0x(_this._chainId.toString(16)); // indicate that we've connected, for EIP-1193 compliance

    _this.emit("connect", {
      chainIdStr: chainIdStr
    });

    var cachedAddresses = _this._storage.getItem(LOCAL_STORAGE_ADDRESSES_KEY);

    if (cachedAddresses) {
      var addresses = cachedAddresses.split(" ");

      if (addresses[0] !== "") {
        _this._addresses = addresses;

        _this.emit("accountsChanged", addresses);
      }
    }

    _this._subscriptionManager.events.on("notification", function (notification) {
      _this.emit("message", {
        type: notification.method,
        data: notification.params
      });
    });

    if (_this._addresses.length > 0) {
      _this.initializeRelay();
    }

    return _this;
  }

  _createClass(WalletLinkProvider, [{
    key: "isConnected",
    value: function isConnected() {
      return true;
    }
  }, {
    key: "setProviderInfo",
    value: function setProviderInfo(jsonRpcUrl, chainId) {
      if (this.isChainOverridden) return;
      this.updateProviderInfo(jsonRpcUrl, chainId, false);
    }
  }, {
    key: "updateProviderInfo",
    value: function updateProviderInfo(jsonRpcUrl, chainId, fromRelay) {
      if (fromRelay) this.isChainOverridden = true;
      var originalChainId = this._chainId;
      this._chainId = util_1.ensureIntNumber(chainId);
      var chainChanged = this._chainId !== originalChainId;
      this._jsonRpcUrl = jsonRpcUrl;

      if (chainChanged || !this.hasMadeFirstChainChangedEmission) {
        this.emit("chainChanged", this._chainId);
        this.hasMadeFirstChainChangedEmission = true;
      }
    }
  }, {
    key: "setAppInfo",
    value: function setAppInfo(appName, appLogoUrl) {
      this.initializeRelay().then(function (relay) {
        return relay.setAppInfo(appName, appLogoUrl);
      });
    }
  }, {
    key: "enable",
    value: function () {
      var _enable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._addresses.length > 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._addresses);

              case 2:
                _context.next = 4;
                return this._send(JSONRPC_1.JSONRPCMethod.eth_requestAccounts);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enable() {
        return _enable.apply(this, arguments);
      }

      return enable;
    }()
  }, {
    key: "close",
    value: function close() {
      this.initializeRelay().then(function (relay) {
        return relay.resetAndReload();
      });
    }
  }, {
    key: "send",
    value: function send(requestOrMethod, callbackOrParams) {
      var _this2 = this;

      // send<T>(method, params): Promise<T>
      if (typeof requestOrMethod === "string") {
        var method = requestOrMethod;
        var params = Array.isArray(callbackOrParams) ? callbackOrParams : callbackOrParams !== undefined ? [callbackOrParams] : [];
        var request = {
          jsonrpc: "2.0",
          id: 0,
          method: method,
          params: params
        };
        return this._sendRequestAsync(request).then(function (res) {
          return res.result;
        });
      } // send(JSONRPCRequest | JSONRPCRequest[], callback): void


      if (typeof callbackOrParams === "function") {
        var _request = requestOrMethod;
        var callback = callbackOrParams;
        return this._sendAsync(_request, callback);
      } // send(JSONRPCRequest[]): JSONRPCResponse[]


      if (Array.isArray(requestOrMethod)) {
        var requests = requestOrMethod;
        return requests.map(function (r) {
          return _this2._sendRequest(r);
        });
      } // send(JSONRPCRequest): JSONRPCResponse


      var req = requestOrMethod;
      return this._sendRequest(req);
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(request, callback) {
      if (typeof callback !== "function") {
        throw new Error("callback is required");
      } // send(JSONRPCRequest[], callback): void


      if (Array.isArray(request)) {
        var arrayCb = callback;

        this._sendMultipleRequestsAsync(request).then(function (responses) {
          return arrayCb(null, responses);
        }).catch(function (err) {
          return arrayCb(err, null);
        });

        return;
      } // send(JSONRPCRequest, callback): void


      var cb = callback;

      this._sendRequestAsync(request).then(function (response) {
        return cb(null, response);
      }).catch(function (err) {
        return cb(err, null);
      });
    }
  }, {
    key: "request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var method, params, newParams, id, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!args || _typeof(args) !== "object" || Array.isArray(args))) {
                  _context2.next = 2;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
                  message: "Expected a single, non-array, object argument.",
                  data: args
                });

              case 2:
                method = args.method, params = args.params;

                if (!(typeof method !== "string" || method.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
                  message: "'args.method' must be a non-empty string.",
                  data: args
                });

              case 5:
                if (!(params !== undefined && !Array.isArray(params) && (_typeof(params) !== "object" || params === null))) {
                  _context2.next = 7;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
                  message: "'args.params' must be an object or array if provided.",
                  data: args
                });

              case 7:
                newParams = params === undefined ? [] : params; // WalletLink Requests

                id = this._relayEventManager.makeRequestId();
                _context2.next = 11;
                return this._sendRequestAsync({
                  method: method,
                  params: newParams,
                  jsonrpc: "2.0",
                  id: id
                });

              case 11:
                result = _context2.sent;
                return _context2.abrupt("return", result.result);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request(_x) {
        return _request2.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "scanQRCode",
    value: function () {
      var _scanQRCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(match) {
        var relay, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.initializeRelay();

              case 2:
                relay = _context3.sent;
                _context3.next = 5;
                return relay.scanQRCode(util_1.ensureRegExpString(match));

              case 5:
                res = _context3.sent;

                if (!(typeof res.result !== "string")) {
                  _context3.next = 8;
                  break;
                }

                throw new Error("result was not a string");

              case 8:
                return _context3.abrupt("return", res.result);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function scanQRCode(_x2) {
        return _scanQRCode.apply(this, arguments);
      }

      return scanQRCode;
    }()
  }, {
    key: "arbitraryRequest",
    value: function () {
      var _arbitraryRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
        var relay, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.initializeRelay();

              case 2:
                relay = _context4.sent;
                _context4.next = 5;
                return relay.arbitraryRequest(data);

              case 5:
                res = _context4.sent;

                if (!(typeof res.result !== "string")) {
                  _context4.next = 8;
                  break;
                }

                throw new Error("result was not a string");

              case 8:
                return _context4.abrupt("return", res.result);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function arbitraryRequest(_x3) {
        return _arbitraryRequest.apply(this, arguments);
      }

      return arbitraryRequest;
    }()
  }, {
    key: "childRequestEthereumAccounts",
    value: function () {
      var _childRequestEthereumAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(childSessionId, childSessionSecret, dappName, dappLogoURL, dappURL) {
        var relay;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.initializeRelay();

              case 2:
                relay = _context5.sent;
                _context5.next = 5;
                return relay.childRequestEthereumAccounts(childSessionId, childSessionSecret, dappName, dappLogoURL, dappURL);

              case 5:
                return _context5.abrupt("return", true);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function childRequestEthereumAccounts(_x4, _x5, _x6, _x7, _x8) {
        return _childRequestEthereumAccounts.apply(this, arguments);
      }

      return childRequestEthereumAccounts;
    }()
  }, {
    key: "supportsSubscriptions",
    value: function supportsSubscriptions() {
      return false;
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      throw new Error("Subscriptions are not supported");
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      throw new Error("Subscriptions are not supported");
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return true;
    }
  }, {
    key: "_sendRequest",
    value: function _sendRequest(request) {
      var response = {
        jsonrpc: "2.0",
        id: request.id
      };
      var method = request.method;
      response.result = this._handleSynchronousMethods(request);

      if (response.result === undefined) {
        throw new Error("WalletLink does not support calling ".concat(method, " synchronously without ") + "a callback. Please provide a callback parameter to call ".concat(method, " ") + "asynchronously.");
      }

      return response;
    }
  }, {
    key: "_setAddresses",
    value: function _setAddresses(addresses) {
      if (!Array.isArray(addresses)) {
        throw new Error("addresses is not an array");
      }

      this._addresses = addresses.map(function (address) {
        return util_1.ensureAddressString(address);
      });
      this.emit("accountsChanged", this._addresses);

      this._storage.setItem(LOCAL_STORAGE_ADDRESSES_KEY, addresses.join(" "));

      window.dispatchEvent(new CustomEvent("walletlink:addresses", {
        detail: this._addresses
      }));
    }
  }, {
    key: "_sendRequestAsync",
    value: function _sendRequestAsync(request) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        try {
          var syncResult = _this3._handleSynchronousMethods(request);

          if (syncResult !== undefined) {
            return resolve({
              jsonrpc: "2.0",
              id: request.id,
              result: syncResult
            });
          }

          var filterPromise = _this3._handleAsynchronousFilterMethods(request);

          if (filterPromise !== undefined) {
            filterPromise.then(function (res) {
              return resolve(Object.assign(Object.assign({}, res), {
                id: request.id
              }));
            }).catch(function (err) {
              return reject(err);
            });
            return;
          }

          var subscriptionPromise = _this3._handleSubscriptionMethods(request);

          if (subscriptionPromise !== undefined) {
            subscriptionPromise.then(function (res) {
              return resolve({
                jsonrpc: "2.0",
                id: request.id,
                result: res.result
              });
            }).catch(function (err) {
              return reject(err);
            });
            return;
          }
        } catch (err) {
          return reject(err);
        }

        _this3._handleAsynchronousMethods(request).then(function (res) {
          return resolve(Object.assign(Object.assign({}, res), {
            id: request.id
          }));
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: "_sendMultipleRequestsAsync",
    value: function _sendMultipleRequestsAsync(requests) {
      var _this4 = this;

      return Promise.all(requests.map(function (r) {
        return _this4._sendRequestAsync(r);
      }));
    }
  }, {
    key: "_handleSynchronousMethods",
    value: function _handleSynchronousMethods(request) {
      var method = request.method;
      var params = request.params || [];

      switch (method) {
        case JSONRPC_1.JSONRPCMethod.eth_accounts:
          return this._eth_accounts();

        case JSONRPC_1.JSONRPCMethod.eth_coinbase:
          return this._eth_coinbase();

        case JSONRPC_1.JSONRPCMethod.eth_uninstallFilter:
          return this._eth_uninstallFilter(params);

        case JSONRPC_1.JSONRPCMethod.net_version:
          return this._net_version();

        case JSONRPC_1.JSONRPCMethod.eth_chainId:
          return this._eth_chainId();

        default:
          return undefined;
      }
    }
  }, {
    key: "_handleAsynchronousMethods",
    value: function _handleAsynchronousMethods(request) {
      var method = request.method;
      var params = request.params || [];

      switch (method) {
        case JSONRPC_1.JSONRPCMethod.eth_requestAccounts:
          return this._eth_requestAccounts();

        case JSONRPC_1.JSONRPCMethod.eth_sign:
          return this._eth_sign(params);

        case JSONRPC_1.JSONRPCMethod.eth_ecRecover:
          return this._eth_ecRecover(params);

        case JSONRPC_1.JSONRPCMethod.personal_sign:
          return this._personal_sign(params);

        case JSONRPC_1.JSONRPCMethod.personal_ecRecover:
          return this._personal_ecRecover(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTransaction:
          return this._eth_signTransaction(params);

        case JSONRPC_1.JSONRPCMethod.eth_sendRawTransaction:
          return this._eth_sendRawTransaction(params);

        case JSONRPC_1.JSONRPCMethod.eth_sendTransaction:
          return this._eth_sendTransaction(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v1:
          return this._eth_signTypedData_v1(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v2:
          return this._throwUnsupportedMethodError();

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v3:
          return this._eth_signTypedData_v3(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v4:
        case JSONRPC_1.JSONRPCMethod.eth_signTypedData:
          return this._eth_signTypedData_v4(params);

        case JSONRPC_1.JSONRPCMethod.walletlink_arbitrary:
          return this._walletlink_arbitrary(params);
      }

      if (!this._jsonRpcUrl) throw Error("Error: No jsonRpcUrl provided");
      return window.fetch(this._jsonRpcUrl, {
        method: "POST",
        body: JSON.stringify(request),
        mode: "cors",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (json) {
        if (!json) {
          throw eth_rpc_errors_1.ethErrors.rpc.parse({});
        }

        var response = json;
        var error = response.error;

        if (error) {
          throw eth_rpc_errors_1.serializeError(error);
        }

        return response;
      });
    }
  }, {
    key: "_handleAsynchronousFilterMethods",
    value: function _handleAsynchronousFilterMethods(request) {
      var method = request.method;
      var params = request.params || [];

      switch (method) {
        case JSONRPC_1.JSONRPCMethod.eth_newFilter:
          return this._eth_newFilter(params);

        case JSONRPC_1.JSONRPCMethod.eth_newBlockFilter:
          return this._eth_newBlockFilter();

        case JSONRPC_1.JSONRPCMethod.eth_newPendingTransactionFilter:
          return this._eth_newPendingTransactionFilter();

        case JSONRPC_1.JSONRPCMethod.eth_getFilterChanges:
          return this._eth_getFilterChanges(params);

        case JSONRPC_1.JSONRPCMethod.eth_getFilterLogs:
          return this._eth_getFilterLogs(params);
      }

      return undefined;
    }
  }, {
    key: "_handleSubscriptionMethods",
    value: function _handleSubscriptionMethods(request) {
      switch (request.method) {
        case JSONRPC_1.JSONRPCMethod.eth_subscribe:
        case JSONRPC_1.JSONRPCMethod.eth_unsubscribe:
          return this._subscriptionManager.handleRequest(request);
      }

      return undefined;
    }
  }, {
    key: "_isKnownAddress",
    value: function _isKnownAddress(addressString) {
      try {
        var address = util_1.ensureAddressString(addressString);
        return this._addresses.includes(address);
      } catch (_a) {}

      return false;
    }
  }, {
    key: "_ensureKnownAddress",
    value: function _ensureKnownAddress(addressString) {
      if (!this._isKnownAddress(addressString)) {
        throw new Error("Unknown Ethereum address");
      }
    }
  }, {
    key: "_prepareTransactionParams",
    value: function _prepareTransactionParams(tx) {
      var fromAddress = tx.from ? util_1.ensureAddressString(tx.from) : this.selectedAddress;

      if (!fromAddress) {
        throw new Error("Ethereum address is unavailable");
      }

      this._ensureKnownAddress(fromAddress);

      var toAddress = tx.to ? util_1.ensureAddressString(tx.to) : null;
      var weiValue = tx.value != null ? util_1.ensureBN(tx.value) : new bn_js_1.default(0);
      var data = tx.data ? util_1.ensureBuffer(tx.data) : Buffer.alloc(0);
      var nonce = tx.nonce != null ? util_1.ensureIntNumber(tx.nonce) : null;
      var gasPriceInWei = tx.gasPrice != null ? util_1.ensureBN(tx.gasPrice) : null;
      var gasLimit = tx.gas != null ? util_1.ensureBN(tx.gas) : null;
      var chainId = this._chainId;
      return {
        fromAddress: fromAddress,
        toAddress: toAddress,
        weiValue: weiValue,
        data: data,
        nonce: nonce,
        gasPriceInWei: gasPriceInWei,
        gasLimit: gasLimit,
        chainId: chainId
      };
    }
  }, {
    key: "_requireAuthorization",
    value: function _requireAuthorization() {
      if (this._addresses.length === 0) {
        throw eth_rpc_errors_1.ethErrors.provider.unauthorized({});
      }
    }
  }, {
    key: "_throwUnsupportedMethodError",
    value: function _throwUnsupportedMethodError() {
      throw eth_rpc_errors_1.ethErrors.provider.unsupportedMethod({});
    }
  }, {
    key: "_signEthereumMessage",
    value: function () {
      var _signEthereumMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(message, address, addPrefix, typedDataJson) {
        var relay, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._ensureKnownAddress(address);

                _context6.prev = 1;
                _context6.next = 4;
                return this.initializeRelay();

              case 4:
                relay = _context6.sent;
                _context6.next = 7;
                return relay.signEthereumMessage(message, address, addPrefix, typedDataJson);

              case 7:
                res = _context6.sent;
                return _context6.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](1);

                if (!(typeof _context6.t0.message === "string" && _context6.t0.message.match(/(denied|rejected)/i))) {
                  _context6.next = 15;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied message signature");

              case 15:
                throw _context6.t0;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 11]]);
      }));

      function _signEthereumMessage(_x9, _x10, _x11, _x12) {
        return _signEthereumMessage2.apply(this, arguments);
      }

      return _signEthereumMessage;
    }()
  }, {
    key: "_ethereumAddressFromSignedMessage",
    value: function () {
      var _ethereumAddressFromSignedMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(message, signature, addPrefix) {
        var relay, res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.initializeRelay();

              case 2:
                relay = _context7.sent;
                _context7.next = 5;
                return relay.ethereumAddressFromSignedMessage(message, signature, addPrefix);

              case 5:
                res = _context7.sent;
                return _context7.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _ethereumAddressFromSignedMessage(_x13, _x14, _x15) {
        return _ethereumAddressFromSignedMessage2.apply(this, arguments);
      }

      return _ethereumAddressFromSignedMessage;
    }()
  }, {
    key: "_eth_accounts",
    value: function _eth_accounts() {
      return this._addresses;
    }
  }, {
    key: "_eth_coinbase",
    value: function _eth_coinbase() {
      return this.selectedAddress || null;
    }
  }, {
    key: "_net_version",
    value: function _net_version() {
      return this._chainId.toString(10);
    }
  }, {
    key: "_eth_chainId",
    value: function _eth_chainId() {
      return util_1.hexStringFromIntNumber(this._chainId);
    }
  }, {
    key: "_eth_requestAccounts",
    value: function () {
      var _eth_requestAccounts2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var res, relay;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this._addresses.length > 0)) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", Promise.resolve({
                  jsonrpc: "2.0",
                  id: 0,
                  result: this._addresses
                }));

              case 2:
                _context8.prev = 2;
                _context8.next = 5;
                return this.initializeRelay();

              case 5:
                relay = _context8.sent;
                _context8.next = 8;
                return relay.requestEthereumAccounts();

              case 8:
                res = _context8.sent;
                _context8.next = 16;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](2);

                if (!(typeof _context8.t0.message === "string" && _context8.t0.message.match(/(denied|rejected)/i))) {
                  _context8.next = 15;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied account authorization");

              case 15:
                throw _context8.t0;

              case 16:
                if (res.result) {
                  _context8.next = 18;
                  break;
                }

                throw new Error("accounts received is empty");

              case 18:
                this._setAddresses(res.result);

                return _context8.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: this._addresses
                });

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[2, 11]]);
      }));

      function _eth_requestAccounts() {
        return _eth_requestAccounts2.apply(this, arguments);
      }

      return _eth_requestAccounts;
    }()
  }, {
    key: "_eth_sign",
    value: function _eth_sign(params) {
      this._requireAuthorization();

      var address = util_1.ensureAddressString(params[0]);
      var message = util_1.ensureBuffer(params[1]);
      return this._signEthereumMessage(message, address, false);
    }
  }, {
    key: "_eth_ecRecover",
    value: function _eth_ecRecover(params) {
      var message = util_1.ensureBuffer(params[0]);
      var signature = util_1.ensureBuffer(params[1]);
      return this._ethereumAddressFromSignedMessage(message, signature, false);
    }
  }, {
    key: "_personal_sign",
    value: function _personal_sign(params) {
      this._requireAuthorization();

      var message = util_1.ensureBuffer(params[0]);
      var address = util_1.ensureAddressString(params[1]);
      return this._signEthereumMessage(message, address, true);
    }
  }, {
    key: "_personal_ecRecover",
    value: function _personal_ecRecover(params) {
      var message = util_1.ensureBuffer(params[0]);
      var signature = util_1.ensureBuffer(params[1]);
      return this._ethereumAddressFromSignedMessage(message, signature, true);
    }
  }, {
    key: "_eth_signTransaction",
    value: function () {
      var _eth_signTransaction2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
        var tx, relay, res;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this._requireAuthorization();

                tx = this._prepareTransactionParams(params[0] || {});
                _context9.prev = 2;
                _context9.next = 5;
                return this.initializeRelay();

              case 5:
                relay = _context9.sent;
                _context9.next = 8;
                return relay.signEthereumTransaction(tx);

              case 8:
                res = _context9.sent;
                return _context9.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](2);

                if (!(typeof _context9.t0.message === "string" && _context9.t0.message.match(/(denied|rejected)/i))) {
                  _context9.next = 16;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied transaction signature");

              case 16:
                throw _context9.t0;

              case 17:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 12]]);
      }));

      function _eth_signTransaction(_x16) {
        return _eth_signTransaction2.apply(this, arguments);
      }

      return _eth_signTransaction;
    }()
  }, {
    key: "_eth_sendRawTransaction",
    value: function () {
      var _eth_sendRawTransaction2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
        var signedTransaction, relay, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                signedTransaction = util_1.ensureBuffer(params[0]);
                _context10.next = 3;
                return this.initializeRelay();

              case 3:
                relay = _context10.sent;
                _context10.next = 6;
                return relay.submitEthereumTransaction(signedTransaction, this._chainId);

              case 6:
                res = _context10.sent;
                return _context10.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _eth_sendRawTransaction(_x17) {
        return _eth_sendRawTransaction2.apply(this, arguments);
      }

      return _eth_sendRawTransaction;
    }()
  }, {
    key: "_eth_sendTransaction",
    value: function () {
      var _eth_sendTransaction2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
        var tx, relay, res;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this._requireAuthorization();

                tx = this._prepareTransactionParams(params[0] || {});
                _context11.prev = 2;
                _context11.next = 5;
                return this.initializeRelay();

              case 5:
                relay = _context11.sent;
                _context11.next = 8;
                return relay.signAndSubmitEthereumTransaction(tx);

              case 8:
                res = _context11.sent;
                return _context11.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11["catch"](2);

                if (!(typeof _context11.t0.message === "string" && _context11.t0.message.match(/(denied|rejected)/i))) {
                  _context11.next = 16;
                  break;
                }

                throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied transaction signature");

              case 16:
                throw _context11.t0;

              case 17:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 12]]);
      }));

      function _eth_sendTransaction(_x18) {
        return _eth_sendTransaction2.apply(this, arguments);
      }

      return _eth_sendTransaction;
    }()
  }, {
    key: "_eth_signTypedData_v1",
    value: function () {
      var _eth_signTypedData_v = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
        var typedData, address, message, typedDataJSON;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this._requireAuthorization();

                typedData = util_1.ensureParsedJSONObject(params[0]);
                address = util_1.ensureAddressString(params[1]);

                this._ensureKnownAddress(address);

                message = eth_eip712_util_1.default.hashForSignTypedDataLegacy({
                  data: typedData
                });
                typedDataJSON = JSON.stringify(typedData, null, 2);
                return _context12.abrupt("return", this._signEthereumMessage(message, address, false, typedDataJSON));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _eth_signTypedData_v1(_x19) {
        return _eth_signTypedData_v.apply(this, arguments);
      }

      return _eth_signTypedData_v1;
    }()
  }, {
    key: "_eth_signTypedData_v3",
    value: function () {
      var _eth_signTypedData_v2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
        var address, typedData, message, typedDataJSON;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this._requireAuthorization();

                address = util_1.ensureAddressString(params[0]);
                typedData = util_1.ensureParsedJSONObject(params[1]);

                this._ensureKnownAddress(address);

                message = eth_eip712_util_1.default.hashForSignTypedData_v3({
                  data: typedData
                });
                typedDataJSON = JSON.stringify(typedData, null, 2);
                return _context13.abrupt("return", this._signEthereumMessage(message, address, false, typedDataJSON));

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _eth_signTypedData_v3(_x20) {
        return _eth_signTypedData_v2.apply(this, arguments);
      }

      return _eth_signTypedData_v3;
    }()
  }, {
    key: "_eth_signTypedData_v4",
    value: function () {
      var _eth_signTypedData_v5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
        var address, typedData, message, typedDataJSON;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this._requireAuthorization();

                address = util_1.ensureAddressString(params[0]);
                typedData = util_1.ensureParsedJSONObject(params[1]);

                this._ensureKnownAddress(address);

                message = eth_eip712_util_1.default.hashForSignTypedData_v4({
                  data: typedData
                });
                typedDataJSON = JSON.stringify(typedData, null, 2);
                return _context14.abrupt("return", this._signEthereumMessage(message, address, false, typedDataJSON));

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function _eth_signTypedData_v4(_x21) {
        return _eth_signTypedData_v5.apply(this, arguments);
      }

      return _eth_signTypedData_v4;
    }()
  }, {
    key: "_walletlink_arbitrary",
    value: function () {
      var _walletlink_arbitrary2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params) {
        var data, result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                data = params[0];

                if (!(typeof data !== "string")) {
                  _context15.next = 3;
                  break;
                }

                throw new Error("parameter must be a string");

              case 3:
                _context15.next = 5;
                return this.arbitraryRequest(data);

              case 5:
                result = _context15.sent;
                return _context15.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: result
                });

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _walletlink_arbitrary(_x22) {
        return _walletlink_arbitrary2.apply(this, arguments);
      }

      return _walletlink_arbitrary;
    }()
  }, {
    key: "_eth_uninstallFilter",
    value: function _eth_uninstallFilter(params) {
      var filterId = util_1.ensureHexString(params[0]);
      return this._filterPolyfill.uninstallFilter(filterId);
    }
  }, {
    key: "_eth_newFilter",
    value: function () {
      var _eth_newFilter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params) {
        var param, filterId;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                param = params[0];
                _context16.next = 3;
                return this._filterPolyfill.newFilter(param);

              case 3:
                filterId = _context16.sent;
                return _context16.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: filterId
                });

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _eth_newFilter(_x23) {
        return _eth_newFilter2.apply(this, arguments);
      }

      return _eth_newFilter;
    }()
  }, {
    key: "_eth_newBlockFilter",
    value: function () {
      var _eth_newBlockFilter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var filterId;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this._filterPolyfill.newBlockFilter();

              case 2:
                filterId = _context17.sent;
                return _context17.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: filterId
                });

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function _eth_newBlockFilter() {
        return _eth_newBlockFilter2.apply(this, arguments);
      }

      return _eth_newBlockFilter;
    }()
  }, {
    key: "_eth_newPendingTransactionFilter",
    value: function () {
      var _eth_newPendingTransactionFilter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var filterId;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this._filterPolyfill.newPendingTransactionFilter();

              case 2:
                filterId = _context18.sent;
                return _context18.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: filterId
                });

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function _eth_newPendingTransactionFilter() {
        return _eth_newPendingTransactionFilter2.apply(this, arguments);
      }

      return _eth_newPendingTransactionFilter;
    }()
  }, {
    key: "_eth_getFilterChanges",
    value: function _eth_getFilterChanges(params) {
      var filterId = util_1.ensureHexString(params[0]);
      return this._filterPolyfill.getFilterChanges(filterId);
    }
  }, {
    key: "_eth_getFilterLogs",
    value: function _eth_getFilterLogs(params) {
      var filterId = util_1.ensureHexString(params[0]);
      return this._filterPolyfill.getFilterLogs(filterId);
    }
  }, {
    key: "initializeRelay",
    value: function initializeRelay() {
      var _this5 = this;

      if (this._relay) {
        return Promise.resolve(this._relay);
      }

      return this._relayProvider().then(function (relay) {
        relay.setChainIdCallback(function (chainId) {
          _this5.updateProviderInfo(_this5._jsonRpcUrl, parseInt(chainId, 10), true);
        });
        relay.setJsonRpcUrlCallback(function (jsonRpcUrl) {
          _this5.updateProviderInfo(jsonRpcUrl, _this5._chainId, true);
        });
        _this5._relay = relay;
        return relay;
      });
    }
  }, {
    key: "selectedAddress",
    get: function get() {
      return this._addresses[0] || undefined;
    }
  }, {
    key: "networkVersion",
    get: function get() {
      return this._chainId.toString(10);
    }
  }, {
    key: "chainId",
    get: function get() {
      return util_1.prepend0x(this._chainId.toString(16));
    }
  }, {
    key: "isWalletLink",
    get: function get() {
      return true;
    }
    /**
     * Some DApps (i.e. Alpha Homora) seem to require the window.ethereum object return
     * true for this method.
     */

  }, {
    key: "isMetaMask",
    get: function get() {
      return this._overrideIsMetaMask;
    }
  }, {
    key: "host",
    get: function get() {
      return this._jsonRpcUrl;
    }
  }, {
    key: "connected",
    get: function get() {
      return true;
    }
  }]);

  return WalletLinkProvider;
}(safe_event_emitter_1.default);

exports.WalletLinkProvider = WalletLinkProvider;